module.exports = __webpack_public_path__ + "img/1700-1_YR_2022_SocialEngineering.a4205641.png";